// PsyPractice / hukuki belgeler / Čeština.
//
// Bölüm sırası, başlık numaraları ve hukuki iddialar TÜM dillerde aynıdır; esasa
// ilişkin bir değişiklik bütün dillerde birlikte yapılır ve shared.ts'teki
// LEGAL_VERSION birlikte artar; aksi hâlde kullanıcının onayladığı sürüm ile
// okuduğu metin ayrışır. Yalnızca çeviri eklemek sürümü ARTIRMAZ.
import { LEGAL_VERSION, MERCHANT, type LegalDoc } from "./shared";

// İşletme türünün ADI dile bağlıdır, resmî bilgiler (ad, adres, vergi) değildir;
// bu yüzden shared.ts'te değil, her dilin kendi dosyasında durur.
const OWNER_TYPE = "Osoba samostatně výdělečně činná";

const OWNER = 'PsyPractice (dále jen „Platforma“ nebo „Správce údajů“)';

export const DOCS: LegalDoc[] = [
  {
    id: "terms",
    title: "Podmínky užívání a vyloučení odpovědnosti",
    description:
      "Povaha a meze služby, co nenahrazuje, závazky uživatele a rozsáhlé vzdání se nároků, které veškerou odpovědnost přenáší na uživatele.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Smluvní strany a přijetí",
        paras: [
          `Tyto Podmínky užívání se uzavírají mezi ${OWNER} a každou fyzickou nebo právnickou osobou, která k Platformě přistupuje nebo ji používá („Uživatel“). Vytvořením účtu, přihlášením nebo jakýmkoli používáním Platformy Uživatel potvrzuje, že si tyto Podmínky přečetl, porozuměl jim a bezvýhradně je v plném rozsahu přijímá a zavazuje se je dodržovat. Kdo tyto Podmínky nepřijímá, nesmí Platformu používat.`,
        ],
      },
      {
        heading: "2. Povaha a meze služby",
        bullets: [
          "PsyPractice je software pro SIMULACI pacientů s podporou AI, který studentům psychologie a začínajícím klinikům umožňuje v bezpečném prostředí provádět a zaznamenávat vlastní procvičování vedení rozhovoru.",
          "PsyPractice není vzdělávací ani výuková služba; je to softwarový nástroj, který uživateli umožňuje provádět a zaznamenávat vlastní praxi. Platforma neposkytuje žádné lekce, učební plán, zkoušky ani doklady a nepropůjčuje žádný titul, kvalifikaci ani oprávnění jakéhokoli druhu.",
          "Simulovaný „pacient“ není skutečný klient; jeho odpovědi jsou syntetizovány umělou inteligencí, mohou být chybné, neúplné, nekonzistentní nebo zavádějící a nenesou žádný nárok na klinickou přesnost či pravdivost.",
        ],
      },
      {
        heading: "2.1. Co Platforma nenahrazuje",
        bullets: [
          "NENÍ to skutečná terapie ani poradenství a nenahrazuje žádné sezení vedené se skutečným klientem.",
          "NENÍ to náhrada klinické supervize. Zprávy se zpětnou vazbou vytvořené supervizorem AI jsou automaticky generovaný text; nejde o odborné stanovisko, oficiální posouzení ani známku.",
          "NENÍ to diagnostický, screeningový ani hodnoticí nástroj; žádný výstup Platformy nesmí být použit pro diagnostické nebo klinické rozhodování o jakékoli skutečné osobě.",
          "NESMÍ být používána v krizích ani naléhavých situacích. V případě sebevražedných myšlenek, rizika ublížení sobě nebo druhým či jakékoli srovnatelné naléhavé situace Platformu zavřete a neprodleně kontaktujte místní záchrannou službu nebo příslušné zdravotnické zařízení.",
          "NENÍ to zdroj odborné způsobilosti, licence, titulu ani oprávnění; čas strávený na Platformě a její výstupy nesmějí být žádné instituci předkládány jako doklad kvalifikace.",
        ],
      },
      {
        heading: "3. Prohlášení a závazky Uživatele",
        bullets: [
          "Uživatel se zavazuje používat Platformu výhradně v zákonných a etických mezích, za účelem rozvoje své vlastní odborné praxe.",
          "Uživatel souhlasí, že NEBUDE zadávat žádné údaje SKUTEČNÝCH pacientů/klientů, identifikační údaje ani zvláštní kategorie údajů o zdravotním stavu žádné osoby; veškeré právní důsledky takového jednání nese výhradně Uživatel.",
          "Uživatel se zavazuje nepoužívat žádný výstup získaný z Platformy pro diagnostiku, léčbu, intervenci ani klinické rozhodování týkající se jakékoli skutečné osoby.",
          "Uživatel odpovídá výhradně sám za svou odbornou způsobilost, rozsah svého oprávnění a dodržování platných profesních a etických předpisů.",
          "Za zabezpečení účtu, důvěrnost hesla a veškerou činnost prováděnou pod účtem Uživatele odpovídá Uživatel.",
          "Účet je osobní; Uživatel se zavazuje, že jej nebude sdílet s jinými osobami a nebude Platformu používat automatizovanými prostředky (boty, skripty apod.). Užívání placených tarifů podléhá limitu férového užívání (v současnosti 60 sezení za kalendářní měsíc), podrobně upravenému ve Smlouvě o prodeji na dálku.",
        ],
      },
      {
        heading: "4. Veškerá odpovědnost leží na Uživateli (vzdání se nároků)",
        paras: [
          "Platforma je poskytována „TAK, JAK JE“ a „JAK JE DOSTUPNÁ“, bez jakékoli výslovné či předpokládané záruky (včetně nepřerušovaného provozu, bezchybnosti, vhodnosti pro určitý účel, přesnosti či aktuálnosti).",
          "Uživatel přijímá a zavazuje se, že je VÝHRADNĚ a OSOBNĚ odpovědný za veškeré přímé, nepřímé, nahodilé, zvláštní či následné škody (včetně majetkové újmy, nemajetkové újmy, újmy na profesní pověsti, ztráty dat, ušlého příjmu a škod způsobených třetím osobám), které vzniknou z používání Platformy nebo z nemožnosti ji používat, ze spoléhání se na výstupy AI nebo z jakéhokoli použití takových výstupů.",
          "V nejširším rozsahu, jaký platné právo připouští, se Uživatel tímto neodvolatelně a bezpodmínečně VZDÁVÁ, nyní i do budoucna, veškerých nároků, žalob a práv na náhradu, které by mohl vznést vůči Platformě, jejím vlastníkům, zaměstnancům, vývojářům, obchodním partnerům a poskytovatelům služeb v souvislosti s jakoukoli újmou, kterou by mohl utrpět v případě jakéhokoli nepříznivého výsledku.",
          "Uživatel se dále zavazuje Platformu plně odškodnit za veškeré nároky, škody, pokuty a náklady (včetně nákladů právního zastoupení), pokud se na Platformu obrátí jakákoli třetí osoba nebo instituce v důsledku zavinění, nedbalosti nebo užívání v rozporu s těmito Podmínkami ze strany Uživatele.",
        ],
      },
      {
        heading: "5. Omezení odpovědnosti",
        paras: [
          "Aniž jsou dotčena kogentní ustanovení platného práva, celková právní odpovědnost Platformy je v každém případě omezena částkou, kterou Uživatel Platformě skutečně zaplatil za 12 měsíců předcházejících události, jež dala vzniknout příslušnému nároku. Při bezplatném užívání je tato částka nulová.",
        ],
      },
      {
        heading: "6. Duševní vlastnictví, změny a ukončení",
        bullets: [
          "Veškerá práva duševního vlastnictví k Platformě, jejímu softwaru, designu, šablonám případů pacientů a obsahu náleží Platformě.",
          "Veškerá převoditelná majetková práva duševního vlastnictví k jakémukoli obsahu, který Uživatel na Platformě vytvoří (včetně terapeutových zpráv, které napíše, přepisů sezení a materiálů z nich odvozených), se považují za postoupená Platformě výhradně, trvale a bezúplatně v okamžiku vytvoření takového obsahu; Platforma smí tento obsah celosvětově a bez omezení používat, rozmnožovat a zpracovávat k jakémukoli účelu, včetně provozu služby, generování zpětné vazby a zlepšování a rozvoje systému (včetně zlepšování strojového učení). Práva Uživatele k osobním údajům podle platných předpisů o ochraně osobních údajů (GDPR / KVKK) nejsou tímto postoupením dotčena a zůstávají vyhrazena.",
          "Platforma si vyhrazuje právo tyto Podmínky a rozsah služby kdykoli a bez předchozího upozornění změnit, pozastavit nebo ukončit.",
          "V případě porušení těchto Podmínek může Platforma účet bez předchozího upozornění pozastavit nebo zrušit.",
        ],
      },
      {
        heading: "7. Rozhodné právo a soudní příslušnost",
        paras: [
          "Tyto Podmínky se řídí právem Turecké republiky. K řešení jakéhokoli sporu, který může vzniknout, jsou příslušné soudy a exekuční úřady Turecké republiky.",
          "Pro spotřebitele s bydlištěm v Evropské unii zůstává vyhrazena ochrana poskytovaná kogentními ustanoveními spotřebitelského práva země jejich bydliště a jejich práva na ochranu osobních údajů podle GDPR; tato volba práva tato kogentní ustanovení nepřevažuje.",
        ],
      },
    ],
  },
  {
    id: "privacy",
    title: "Zásady ochrany osobních údajů",
    description:
      "GDPR jako základní standard; zpracovávané údaje, právní základy, hostování v EU, mezinárodní předávání (poskytovatel AI) a ustanovení o přeshraničním předávání podle čl. 9 KVKK pro uživatele v Turecku.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          `Tyto Zásady ochrany osobních údajů vysvětlují, jak jsou osobní údaje zpracovávány v rámci Platformy provozované ${OWNER}. Jako základní standard ochrany údajů se zásady řídí obecným nařízením EU o ochraně osobních údajů (GDPR / 2016/679); pro uživatele nacházející se v Turecku se navíc uplatní turecký zákon o ochraně osobních údajů č. 6698 (KVKK), zejména jeho článek 9 o předávání do zahraničí. Informační sdělení KVKK a Prohlášení o výslovném souhlasu jsou nedílnou součástí těchto zásad.`,
        ],
      },
      {
        heading: "Správce údajů a místo hostování",
        bullets: [
          "Správce údajů: PsyPractice. Žádosti subjektů údajů se vyřizují prostřednictvím kontaktního kanálu oznámeného na Platformě (kontaktní e-mail: info@psycora.com).",
          "Hostování: Platforma a její databáze jsou hostovány v Evropské unii, v datovém centru v Nizozemsku (Oracle Cloud). U uživatelů nacházejících se v EU/EHP jsou údaje zpracovávány a ukládány v rámci EU.",
          "Poskytovatel hostingu vystupuje výhradně jako zpracovatel, na základě uzavřené smlouvy o zpracování osobních údajů (DPA).",
        ],
      },
      {
        heading: "Shromažďované údaje",
        bullets: [
          "Údaje o účtu: jméno, e-mail, hashované heslo, informace o předplatném/plánu.",
          "Údaje o používání: vytvořená sezení, přepisy sezení, vygenerované případy pacientů, zprávy se zpětnou vazbou supervizora.",
          "Technické údaje: záznamy o relacích, IP adresa, jazykové nastavení prohlížeče, protokoly o omezení počtu požadavků a zabezpečení.",
        ],
      },
      {
        heading: "Účely zpracování a právní základ (čl. 6 GDPR)",
        bullets: [
          "Plnění smlouvy (čl. 6 odst. 1 písm. b)): vytvoření účtu, vedení sezení, paměť pacienta napříč sezeními, hodnocení supervizorem, správa předplatného a limitů užívání.",
          "Oprávněný zájem (čl. 6 odst. 1 písm. f)): bezpečnost, prevence zneužití, zlepšování systému a odstraňování chyb.",
          "Právní povinnost (čl. 6 odst. 1 písm. c)): uchovávání/vykazování vyplývající z právních předpisů.",
          "Souhlas (čl. 6 odst. 1 písm. a)): zpracování pro analytiku a zlepšování produktu, které není pro službu nezbytně nutné, a tam, kde je to vyžadováno, předávání mimo EU/EHP.",
        ],
      },
      {
        heading: "Mezinárodní předávání",
        paras: [
          "Protože hostování probíhá v EU (Nizozemsko), jsou údaje uživatelů z EU/EHP zpravidla zpracovávány v rámci EU bez předávání do třetí země na této vrstvě. Pro generování odpovědí AI se však obsah sezení a prompty předávají poskytovateli služby AI (Anthropic), jehož zpracovatelská infrastruktura se může nacházet mimo EU/EHP (např. ve Spojených státech).",
          "Taková předávání mimo EU/EHP se opírají o vhodné záruky podle čl. 44 a násl. GDPR, zejména o standardní smluvní doložky Evropské komise (SCC), a s poskytovatelem je uzavřena smlouva o zpracování osobních údajů (DPA). Platforma osobní údaje NEPRODÁVÁ pro marketingové účely; údaje nejsou sdíleny s třetími stranami s výjimkou případů nezbytně nutných pro provoz služby (s výhradou zákonných žádostí příslušných orgánů).",
        ],
      },
      {
        heading: "Pro uživatele v Turecku: čl. 9 KVKK (předávání do zahraničí)",
        paras: [
          "Osobní údaje uživatelů nacházejících se v Turecku jsou předávány mimo Turecko, protože hostování probíhá v Nizozemsku (EU), a mohou být rovněž předávány společnosti Anthropic pro zpracování AI. Tato předávání spadají pod čl. 9 KVKK a opírají se o vhodné záruky (standardní smlouvu / závazek zveřejněný Radou) nebo, tam kde je to vyžadováno, o váš výslovný souhlas. Rozsah, příjemci a účel předávání jsou podrobně popsány v Informačním sdělení KVKK a v Prohlášení o výslovném souhlasu.",
        ],
      },
      {
        heading: "Práva subjektů údajů (čl. 15 až 22 GDPR)",
        bullets: [
          "Přístup, oprava, výmaz („právo být zapomenut“) a omezení zpracování.",
          "Přenositelnost údajů: získání údajů, které jste poskytli, ve strukturovaném, běžně používaném a strojově čitelném formátu.",
          "Námitka: vznesení námitky proti zpracování založenému na oprávněném zájmu a proti přímému marketingu.",
          "Práva související s výhradně automatizovaným individuálním rozhodováním/profilováním.",
          "Odvolání souhlasu kdykoli u zpracování založeného na souhlasu (odvolání nemá vliv na zákonnost zpracování provedeného do té doby).",
          "Právo podat stížnost u dozorového úřadu: u příslušného úřadu pro ochranu osobních údajů v EU; u Úřadu pro ochranu osobních údajů (KVKK) v Turecku.",
        ],
      },
      {
        heading: "Uchovávání a zabezpečení",
        bullets: [
          "Údaje jsou uchovávány po dobu, kterou vyžaduje účel zpracování, a po dobu stanovenou platnými právními předpisy; po uplynutí této doby jsou vymazány nebo anonymizovány.",
          "Citlivá pole (např. heslo, ověřovací kódy a kódy pro obnovení) jsou uchovávána v šifrované/hashované podobě; přístup je vázán na oprávnění.",
          "Protože žádný způsob přenosu ani ukládání není stoprocentně bezpečný, absolutní bezpečnost nelze zaručit.",
        ],
      },
      {
        heading: "Zákaz údajů skutečných pacientů",
        paras: [
          "Platforma je simulační software; zadávání osobních/zdravotních údajů skutečných klientů je zakázáno. Veškerou odpovědnost vyplývající ze zadání údajů v rozporu s tímto zákazem nese výhradně Uživatel.",
        ],
      },
    ],
  },
  {
    id: "kvkk",
    title: "Informační sdělení KVKK",
    description:
      "Správce údajů, účely zpracování, právní základ, předávání a práva subjektů údajů podle článku 10 zákona č. 6698.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Správce údajů",
        paras: [
          `Podle článku 10 tureckého zákona o ochraně osobních údajů č. 6698 („KVKK“) jsou vaše osobní údaje zpracovávány ${OWNER} jakožto Správcem údajů v rozsahu popsaném níže.`,
        ],
      },
      {
        heading: "Zpracovávané údaje a účely",
        bullets: [
          "Identifikační/kontaktní údaje (jméno, e-mail): vytvoření účtu, ověření totožnosti, komunikace.",
          "Zákaznické transakce (předplatné, plán, využití): poskytování služby, fakturace, uplatňování limitů.",
          "Bezpečnost transakcí (relace, IP adresa, protokoly): bezpečnost, prevence zneužití, právní povinnost.",
          "Uživatelský obsah (přepisy sezení, vygenerované případy): poskytování softwarové služby a generování zpětné vazby.",
          "Členství v institucionální kohortě (identifikátor kohorty, doba členství): pokud se uživatel připojí ke kohortě vedené institucí, viditelnost pro instruktora a správa kohorty.",
        ],
      },
      {
        heading: "Právní základ (čl. 5)",
        bullets: [
          "Uzavření/plnění smlouvy: údaje nezbytné pro poskytování služby.",
          "Oprávněný zájem správce údajů: bezpečnost, prevence podvodů, zlepšování systému.",
          "Právní povinnost: uchovávání/vykazování vyplývající z právních předpisů.",
          "Výslovný souhlas: předávání do zahraničí (čl. 9) a další zpracování, které není pro službu nezbytně nutné.",
        ],
      },
      {
        heading: "Předávání do zahraničí (čl. 9)",
        paras: [
          "Protože Platforma a její databáze jsou hostovány v Evropské unii, v datovém centru v Nizozemsku (Oracle Cloud), jsou osobní údaje uživatelů nacházejících se v Turecku předávány mimo Turecko (do EU). Kromě toho mohou být pro generování odpovědí AI obsah sezení a prompty předávány poskytovateli služby AI (Anthropic), jehož zpracovatelská infrastruktura se může nacházet mimo EU/EHP (např. ve Spojených státech).",
          "Tato předávání do zahraničí spadají pod čl. 9 KVKK a opírají se o vhodné záruky, jako je standardní smlouva / závazek zveřejněný Radou, nebo, tam kde je to vyžadováno, o váš výslovný souhlas. S poskytovateli hostingu a služeb jsou uzavřeny smlouvy o zpracování osobních údajů (DPA).",
        ],
      },
      {
        heading: "Institucionální kohorty a viditelnost pro instruktora",
        paras: [
          "Pokud se připojíte ke kohortě otevřené univerzitou, klinikou nebo obdobnou institucí, může obsah vašich sezení (přepisy) a supervizní zprávy po dobu trvání kohorty vidět instruktor této kohorty. Tato viditelnost se týká pouze vašich sezení spojených s kohortou a končí s koncem vašeho členství v kohortě.",
          "Tento přístup se získává prostřednictvím SAMOSTATNÉ obrazovky výslovného souhlasu zobrazené při připojení ke kohortě; není součástí obecného přijetí Platformy. Pokud tento souhlas neudělíte, nemůžete se ke kohortě připojit, ale můžete Platformu dál používat individuálně přesně jako dosud. Odvolání souhlasu ukončí vaše členství v kohortě a vaše individuální používání zůstane nedotčeno.",
        ],
      },
      {
        heading: "Práva subjektů údajů (čl. 11)",
        bullets: [
          "Dozvědět se, zda jsou vaše osobní údaje zpracovávány, a pokud ano, požadovat informace.",
          "Dozvědět se účel zpracování a zda jsou údaje používány v souladu s tímto účelem.",
          "Znát třetí strany, kterým jsou údaje předávány v tuzemsku nebo v zahraničí.",
          "Požadovat opravu neúplného/nesprávného zpracování a, jsou-li splněny podmínky, výmaz/zničení.",
          "Vznést námitku proti výsledku ve váš neprospěch vzniklému výhradně z automatizované analýzy.",
          "Požadovat náhradu škody utrpěné v důsledku protiprávního zpracování.",
        ],
      },
      {
        heading: "Žádosti",
        paras: [
          "Žádosti týkající se vašich práv můžete podávat prostřednictvím kontaktního kanálu oznámeného Správcem údajů. Žádosti jsou vyřizovány ve lhůtách stanovených KVKK a jeho prováděcími předpisy.",
        ],
      },
    ],
  },
  {
    id: "consent",
    title: "Prohlášení o výslovném souhlasu",
    description:
      "Odděleně od informačního sdělení; svobodně udělený souhlas s předáváním do zahraničí a zpracováním AI.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Prohlašuji, že jsem si přečetl(a) Informační sdělení KVKK a porozuměl(a) mu a že svobodně, informovaně a výslovně souhlasím se zpracováním popsaným níže. (Podle rozhodnutí Rady KVKK č. 2018/90 se výslovný souhlas získává odděleně od informační povinnosti.)",
        ],
      },
      {
        heading: "Zpracování, s nímž je souhlas udělen",
        bullets: [
          "Předávání mých osobních údajů mimo Turecko a jejich ukládání a zpracování tam, protože Platforma je hostována v Evropské unii (Nizozemsko / Oracle Cloud) (čl. 9 KVKK).",
          "Předávání a zpracování mých přepisů sezení a promptů u poskytovatele služby AI (Anthropic), jehož zpracovatelská infrastruktura se může nacházet mimo EU/EHP, za účelem generování odpovědí AI (čl. 9 KVKK).",
          "Zpracování pro zlepšování produktu a analytiku, které není pro poskytování služby nezbytně nutné.",
          "Přijímání oznámení souvisejících se službou.",
        ],
      },
      {
        heading: "Odvolání souhlasu",
        paras: [
          "Beru na vědomí, že svůj výslovný souhlas mohu kdykoli odvolat; protože je však předávání do zahraničí poskytovateli AI technicky nezbytné pro fungování služby, přijímám, že odvolání tohoto souhlasu může vést k tomu, že nebudu moci používat příslušné funkce nebo službu jako celek. Odvolání nemá vliv na zákonnost zpracování provedeného do data odvolání.",
        ],
      },
    ],
  },
  {
    // Counterpart of the TR "outreach" notice / see the comment there.
    id: "outreach",
    title: "Informační sdělení k oslovovací komunikaci",
    description:
      "Pro akademické pracovníky a institucionální kontakty, kteří obdrželi firemní oslovovací e-mail: odkud údaje pocházejí, proč jsou zpracovávány, právní základ a jak se odhlásit.",
    updated: "2026-08-06",
    sections: [
      {
        paras: [
          "Toto sdělení informuje příjemce firemních oslovovacích e-mailů, které PsyPractice zasílá univerzitním katedrám psychologie a jejich akademickým pracovníkům, v souladu s článkem 10 tureckého zákona o ochraně osobních údajů č. 6698 (KVKK) a se Sdělením o postupech a zásadách plnění informační povinnosti. Protože vaše osobní údaje nebyly získány přímo od vás, je informace poskytnuta nejpozději v okamžiku prvního kontaktu, a proto na toto sdělení oslovovací e-mail odkazuje.",
        ],
      },
      {
        heading: "1. Správce údajů",
        bullets: [
          `Jméno: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Adresa: ${MERCHANT.addressEn}`,
          `Finanční úřad / DIČ: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-mail: ${MERCHANT.email}`,
          `Web: ${MERCHANT.website}`,
        ],
      },
      {
        heading: "2. Zpracovávané údaje a jejich zdroj",
        paras: [
          "Zpracování je omezeno na profesní kontaktní údaje: jméno, akademický titul, univerzita a katedra, institucionální e-mailová adresa a, pokud je zveřejněno, institucionální telefonní číslo.",
          "Tyto údaje nebyly shromážděny od vás, ale sestaveny z veřejně zveřejněných oficiálních stránek kateder a fakult univerzit. Nejsou zpracovávány žádné zvláštní kategorie údajů a pro oslovování se nepoužívají soukromé (neinstitucionální) e-mailové adresy.",
        ],
      },
      {
        heading: "3. Účel",
        paras: [
          "Vaše údaje jsou zpracovávány za účelem představení softwarového nástroje vytvořeného pro studium psychologie, pozvání vaší katedry k případnému rozhovoru o pilotním provozu nebo spolupráci a vedení související korespondence. Nejsou používány k žádnému jinému účelu, nejsou prodávány ani předávány třetím stranám pro marketing.",
        ],
      },
      {
        heading: "4. Právní základ",
        paras: [
          "Zpracování se opírá o oprávněné zájmy správce údajů podle článku 5/2-(f) KVKK, pokud tím nejsou dotčena vaše základní práva a svobody: kontakt probíhá pouze na institucionální adresu, pouze ve věci přímo související s profesním oborem příjemce a pouze v omezeném počtu případů.",
          "Pouhá skutečnost, že jsou údaje veřejně dostupné online, není sama o sobě právním základem. Rada pro ochranu osobních údajů rozhodla, že veřejná dostupnost údajů neznamená jejich použitelnost k jakémukoli účelu a že záměr a účel zveřejnění je třeba posuzovat samostatně; na článek 5/2-(d) se proto neodkazuje.",
        ],
      },
      {
        heading: "5. Předávání a uchovávání",
        paras: [
          "Korespondence probíhá prostřednictvím poskytovatele e-mailových služeb, jehož infrastruktura se může nacházet v zahraničí; taková předávání se provádějí s vhodnými zárukami podle článku 9 KVKK.",
          "Vaše údaje jsou vymazány, jakmile účel kontaktu pomine, nebo na vaši žádost. Po žádosti o výmaz se uchovává pouze přísně omezený záznam „nekontaktovat“, a to výhradně proto, aby bylo zajištěno, že už nebudete kontaktováni; pro oslovování se nikdy nepoužívá.",
        ],
      },
      {
        heading: "6. Obchodní elektronická sdělení a právo je odmítnout",
        paras: [
          "Propagační zprávy spadají do působnosti zákona č. 6563 o regulaci elektronického obchodu. Můžete je odmítnout bez udání důvodu; odmítnutí se zpracují nejpozději do tří pracovních dnů, poté již žádná další propagační zpráva zaslána nebude. Stačí odpovědět na obdržený e-mail nebo napsat na " + MERCHANT.email + ".",
        ],
      },
      {
        heading: "7. Vaše práva",
        paras: [
          "Podle článku 11 KVKK máte právo dozvědět se, zda jsou vaše osobní údaje zpracovávány, požadovat o tom informace, dozvědět se účel zpracování a zda jsou údaje používány v souladu s ním, znát třetí strany, jimž jsou předávány v Turecku nebo v zahraničí, požadovat opravu neúplných nebo nepřesných údajů, požadovat výmaz nebo zničení, požadovat oznámení těchto úkonů třetím stranám, vznést námitku proti výsledku ve váš neprospěch vzniklému výhradně automatizovanou analýzou a požadovat náhradu utrpěné škody.",
          `Žádosti lze zasílat na ${MERCHANT.email} a jsou zodpovězeny nejpozději do třiceti dnů. Zachováváte si rovněž právo podat stížnost u Rady pro ochranu osobních údajů.`,
        ],
      },
    ],
  },
  {
    id: "cookies",
    title: "Zásady používání cookies",
    description: "Druhy používaných cookies, jejich účely a správa předvoleb.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Platforma používá cookies a obdobné technologie místního úložiště (localStorage) k udržení vaší relace a zapamatování vašich předvoleb.",
        ],
      },
      {
        heading: "Používané technologie",
        bullets: [
          "Nezbytně nutné: token relace/ověření, zabezpečení. Bez nich služba nefunguje.",
          "Funkční: jazykové nastavení (NEXT_LOCALE), předvolby rozhraní (např. motiv).",
          "Výkonnostní/bezpečnostní: technické protokoly pro omezení počtu požadavků a detekci zneužití.",
        ],
      },
      {
        heading: "Správa předvoleb",
        paras: [
          "Cookies můžete ve svém prohlížeči smazat nebo zablokovat; zablokování nezbytně nutných cookies však znemožní přihlášení a základní funkce. V souladu se zásadami GDPR / ePrivacy a Příručkou KVKK k cookies se cookies, které nejsou nezbytné, používají pouze na základě vaší výslovné předvolby/souhlasu.",
        ],
      },
    ],
  },
  {
    id: "about",
    title: "O nás",
    description:
      "Účel PsyPractice, nabízená služba a kontaktní údaje obchodníka (prodávajícího).",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "PsyPractice je platforma pro simulaci pacientů a klinické dovednosti s podporou AI, vytvořená pro studenty psychologie a čerstvě absolvované, začínající kliniky. Uživatelé vedou textová terapeutická sezení; na konci každého sezení supervizor AI rozhovor vyhodnotí a vytvoří rozvojovou zprávu se zpětnou vazbou. Pacient AI přenáší terapeutický vztah sezení po sezení díky paměti napříč sezeními.",
        ],
      },
      {
        heading: "Naše poslání",
        paras: [
          "Naším cílem je dát budoucím odborníkům v oblasti duševního zdraví bezpečné, opakovatelné prostředí, ve kterém mohou procvičovat dovednosti vedení rozhovoru bez jakéhokoli rizika ublížení skutečným klientům. PsyPractice není vzdělávací ani výuková služba; je to softwarový nástroj, který uživateli umožňuje provádět a zaznamenávat vlastní praxi. Není to skutečná terapie ani poradenství, není to náhrada klinické supervize, není to diagnostický ani hodnoticí nástroj a nesmí být používána v krizích ani naléhavých situacích.",
        ],
      },
      {
        heading: "Co nabízíme",
        bullets: [
          "Simulaci textových terapeutických sezení napříč rozmanitými profily pacientů syntetizovanými z klinické literatury.",
          "Automatizované hodnoticí zprávy supervizora po každém sezení.",
          "Model „živého pacienta“ s pamětí napříč sezeními, který v čase rozvíjí terapeutický vztah.",
          "Generování vlastních pacientů, díky němuž si studenti mohou vytvářet vlastní případy AI.",
          "Metriky pokroku, které sledují rozvoj mikrodovedností.",
        ],
      },
      {
        heading: "Údaje o prodávajícím / podnikateli",
        bullets: [
          `Obchodní jméno: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Adresa: ${MERCHANT.addressEn}`,
          `Finanční úřad / DIČ: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-mail: ${MERCHANT.email}`,
          `Web: ${MERCHANT.website}`,
        ],
      },
    ],
  },
  {
    id: "distance-sales",
    title: "Smlouva o prodeji na dálku",
    description:
      "Prodávající, kupující, služba, cena, platba, plnění a podmínky práva na odstoupení podle tureckého zákona č. 6502 a Nařízení o smlouvách uzavíraných na dálku.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Smluvní strany",
        bullets: [
          `PRODÁVAJÍCÍ: ${MERCHANT.legalName} (${OWNER_TYPE}). Adresa: ${MERCHANT.addressEn}. Finanční úřad / DIČ: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}. E-mail: ${MERCHANT.email}.`,
          "KUPUJÍCÍ: fyzická nebo právnická osoba, která si na Platformě vytvoří účet a zakoupí placené předplatné („Kupující“).",
        ],
      },
      {
        heading: "2. Předmět smlouvy",
        paras: [
          "Předmětem této smlouvy je určení práv a povinností stran v souladu s tureckým zákonem č. 6502 o ochraně spotřebitele a Nařízením o smlouvách uzavíraných na dálku ohledně prodeje a plnění předplatného digitální služby, které Kupující zakoupil elektronicky prostřednictvím Platformy a jehož vlastnosti a prodejní cena jsou uvedeny níže.",
        ],
      },
      {
        heading: "3. Povaha služby a cena",
        bullets: [
          "Prodávanou službou jsou funkce simulace pacientů s podporou AI nabízené v rámci placeného plánu předplatného softwaru PsyPractice (digitální služba / právo užívat software).",
          "PsyPractice není vzdělávací ani výuková služba; je to softwarový nástroj, který uživateli umožňuje provádět a zaznamenávat vlastní praxi. Poplatek za předplatné je protiplněním za přístup k tomuto softwaru; není to poplatek za lekce, učební plán, zkoušky, poradenství ani jakýkoli doklad.",
          "Obsah tarifu, doba (měsíční, 4měsíční období nebo roční) a aktuální cena jsou v okamžiku nákupu zřetelně uvedeny na stránce s cenami/platbou Platformy; celková částka včetně daní je Kupujícímu sdělena před platbou.",
          "Ceny platí v měně zobrazené na Platformě; není-li předplatné zrušeno, obnovuje se na konci zvoleného období automaticky za stejnou cenu.",
          "U tarifů nabízených jako „neomezená sezení“ podléhá užívání limitu férového užívání (v současnosti 60 sezení za kalendářní měsíc). Po dosažení limitu lze nová sezení opět zahajovat od prvního dne následujícího kalendářního měsíce; nevzniká tím nárok na slevu ani vrácení peněz. Limit slouží k zamezení sdílení účtů a automatizovaného užívání a Prodávající jej během zaplaceného období předplatného nezmění v neprospěch Kupujícího.",
        ],
      },
      {
        heading: "4. Platba",
        paras: [
          "Platby jsou bezpečně přijímány kreditní/debetní kartou prostřednictvím licencované platební instituce iyzico. Údaje o kartě Prodávající neukládá; platba se zpracovává prostřednictvím zabezpečených systémů iyzico. U opakovaných plateb (předplatné) je částka automaticky stržena v každém období obnovení z karty schválené Kupujícím.",
        ],
      },
      {
        heading: "5. Plnění a dodání",
        paras: [
          "Služba je digitální a nezahrnuje žádné fyzické dodání. Po potvrzení platby jsou funkce předplatného v účtu Kupujícího zpřístupněny okamžitě. Plnění probíhá elektronicky poskytováním nepřetržitého přístupu po celou dobu trvání předplatného.",
        ],
      },
      {
        heading: "6. Právo na odstoupení a jeho výjimka",
        bullets: [
          "Podle článku 15/1-(ğ) Nařízení o smlouvách uzavíraných na dálku nelze právo na odstoupení uplatnit u nehmotného (digitálního) zboží/služeb plněných okamžitě v elektronické podobě, pokud plnění začalo se souhlasem Kupujícího.",
          "Kupující v okamžiku nákupu bere na vědomí, že služba bude plněna okamžitě, a že tudíž právo na odstoupení nevzniká. Kupující může předplatné kdykoli zrušit, a tím zastavit obnovení; zrušení nabývá účinnosti na konci aktuálního zaplaceného období.",
          "Podrobné podmínky vrácení peněz viz „Podmínky dodání a vrácení peněz“.",
        ],
      },
      {
        heading: "7. Spory a nabytí účinnosti",
        paras: [
          "V případě sporu se Kupující může obrátit na Rozhodčí výbor pro spotřebitelské spory nebo na spotřebitelské soudy v místě svého bydliště v rámci peněžních limitů vyhlášených Ministerstvem obchodu. Tato smlouva je uzavřena a nabývá účinnosti schválením Kupujícím v elektronické podobě.",
        ],
      },
    ],
  },
  {
    id: "delivery-refund",
    title: "Podmínky dodání a vrácení peněz",
    description:
      "Dodání digitální služby, zrušení předplatného, výjimka z práva na odstoupení a podmínky vrácení peněz.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Dodání (digitální služba)",
        bullets: [
          "PsyPractice je zcela digitální služba; neexistuje žádná fyzická zásilka ani doručení kurýrem.",
          "V okamžiku potvrzení platby se funkce předplatného v účtu Kupujícího aktivují automaticky a okamžitě; neexistuje žádná samostatná dodací lhůta ani poplatek za dodání.",
          "Ke službě se přistupuje prostřednictvím webového prohlížeče na jakémkoli zařízení připojeném k internetu.",
        ],
      },
      {
        heading: "Zrušení předplatného",
        bullets: [
          "Kupující může předplatné kdykoli zrušit v nastavení účtu. Zrušení nabývá účinnosti na konci aktuálního zaplaceného období a zastaví další automatické obnovení.",
          "Po zrušení přístup ke službě pokračuje po zbytek zaplaceného období.",
        ],
      },
      {
        heading: "Právo na odstoupení a vrácení peněz",
        bullets: [
          "Protože jde o digitální službu plněnou okamžitě se souhlasem Kupujícího, podle článku 15/1-(ğ) Nařízení o smlouvách uzavíraných na dálku zpravidla nevzniká právo na odstoupení, a tedy ani právo na vrácení peněz.",
          "V případech zjevné vady, jako je chybné/duplicitní stržení platby, úplná nemožnost přístupu ke službě z technických důvodů apod., může Kupující požádat o vrácení peněz kontaktováním Prodávajícího v přiměřené lhůtě od data platby.",
          `Žádosti o vrácení peněz se zasílají na ${MERCHANT.email}; schválené vratky jsou vraceny na kartu použitou k platbě prostřednictvím infrastruktury iyzico, zpravidla do 14 dnů. Lhůta vrácení se může lišit podle doby zpracování bankou.`,
        ],
      },
      {
        heading: "Kontakt",
        paras: [
          `Pro všechny záležitosti týkající se dodání, zrušení a vrácení peněz: ${MERCHANT.email}${MERCHANT.phone ? " · " + MERCHANT.phone : ""}.`,
        ],
      },
    ],
  },
];
